import React from 'react'
import PropTypes from 'prop-types'

import routes from 'src/lib/rails-routes/rails-routes'
import UnitExercise from 'src/ui/UnitExercise/UnitExercise'
import Action from 'src/ui/Action/Action'
import { usePageParams } from 'src/utils/params'
import { t } from 'src/lib/i18n-react'

import UnitExercisesPreviewSkeleton from './UnitExercisesPreviewSkeleton'

const UnitExercisesPreview = ({
  allUnitExercisesLink,
  exercises,
  parentSideGap,
  showExerciseRating,
}) => {
  const { l2Code } = usePageParams()

  return (
    <UnitExercisesPreviewSkeleton
      parentSideGap={parentSideGap}
      titleSection={t('Live Lesson Exercises')}
      moreSection={
        <Action href={allUnitExercisesLink}>{t('See all exercises')}</Action>
      }
      items={exercises}
      ItemComponent={(item) => {
        return (
          <UnitExercise
            item={item}
            linkUrl={routes.exercises_show(l2Code, item.id)}
            showExerciseRating={showExerciseRating}
          />
        )
      }}
    />
  )
}

UnitExercisesPreview.propTypes = {
  parentSideGap: PropTypes.object,
  allUnitExercisesLink: PropTypes.string.isRequired,
  showExerciseRating: PropTypes.bool.isRequired,
  exercises: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default UnitExercisesPreview
